import styled from 'styled-components/macro';

import { Open } from 'assets/media/icons/Open';

export const Burger = styled(Open)`
    margin-left: auto;
`;
